import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getEnv } from 'utilities/environment';
import { buildCheckoutPath } from '../pages/checkout/utilities';

/*
  For full use:
    LOCAL_INSTALLMENTS=true rails s
    Sq::User.create!
 */

const DevNavLinks = () => {
  if (getEnv() !== 'development') {
    return null;
  }

  const history = useHistory();

  return (
    <nav>
      <ul>
        <li>
          <Link to={`${buildCheckoutPath(history, '/information')}`}>
            Information
          </Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/shipping_method')}`}>
            Shipping
          </Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/payment_option')}`}>
            Payment Option
          </Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/offer_select')}`}>
            Offer Select
          </Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/finance_app')}`}>
            Finance App
          </Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/payment')}`}>Payment</Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/review')}`}>Review</Link>
        </li>
        <li>
          <Link to={`${buildCheckoutPath(history, '/complete')}`}>
            Complete
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default DevNavLinks;
